import React from "react";
import {
  Box,
  Grid,
  Container,
  IconButton,
  Stack,
  Typography,
  Button,
  Link,
} from "@mui/material";
import AdBanner from "../components/AdBanner";
import ChallengePack from "../components/ChallengePack";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import privacyOptions from "../assets/privacyoptions.png";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import { logEngagement } from "../helper/log.helper";

const programData = {
  id: 1,
  name: "Program 1",
  categories: [
    {
      name: "Diagnosis",
      packs: [
        {
          id: 1,
          name: "Challenge 1",
          slug: "challenge-1",
        },
        {
          id: 2,
          name: "Challenge 2",
          slug: "challenge-2",
        },
        {
          id: 3,
          name: "Challenge 3",
          slug: "challenge-3",
        },
        {
          id: 4,
          name: "Challenge 4",
          slug: "challenge-4",
        },
      ],
    },
    {
      name: "Treatment",
      packs: [
        {
          id: 1,
          name: "Challenge 1",
          slug: "challenge-1",
        },
        {
          id: 2,
          name: "Challenge 2",
          slug: "challenge-2",
        },
        {
          id: 3,
          name: "Challenge 3",
          slug: "challenge-3",
        },
        {
          id: 4,
          name: "Challenge 4",
          slug: "challenge-4",
        },
      ],
    },
    {
      name: "Industry/Disease State/Specialty Knowledge",
      packs: [
        {
          id: 1,
          name: "Challenge 1",
          slug: "challenge-1",
        },
        {
          id: 2,
          name: "Challenge 2",
          slug: "challenge-2",
        },
        {
          id: 3,
          name: "Challenge 3",
          slug: "challenge-3",
        },
        {
          id: 4,
          name: "Challenge 4",
          slug: "challenge-4",
        },
      ],
    },
    {
      name: "Clinical Data",
      packs: [
        {
          id: 1,
          name: "Challenge 1",
          slug: "challenge-1",
        },
        {
          id: 2,
          name: "Challenge 2",
          slug: "challenge-2",
        },
        {
          id: 3,
          name: "Challenge 3",
          slug: "challenge-3",
        },
        {
          id: 4,
          name: "Challenge 4",
          slug: "challenge-4",
        },
      ],
    },
    {
      name: "MOA/MOD",
      packs: [
        {
          id: 1,
          name: "Challenge 1",
          slug: "challenge-1",
        },
        {
          id: 2,
          name: "Challenge 2",
          slug: "challenge-2",
        },
        {
          id: 3,
          name: "Challenge 3",
          slug: "challenge-3",
        },
        {
          id: 4,
          name: "Challenge 4",
          slug: "challenge-4",
        },
      ],
    },
    {
      name: "Other General",
      packs: [
        {
          id: 1,
          name: "Challenge 1",
          slug: "challenge-1",
        },
        {
          id: 2,
          name: "Challenge 2",
          slug: "challenge-2",
        },
        {
          id: 3,
          name: "Challenge 3",
          slug: "challenge-3",
        },
        {
          id: 4,
          name: "Challenge 4",
          slug: "challenge-4",
        },
      ],
    },
  ],
};
const Home = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const utmCampaign =
    searchParams.get("utm_campaign") || searchParams.get("utm_campaign ");
  const settings = useSelector((state) => state.siteSettings);
  const ipAddress = useSelector((state) => state.ipAddress);
  const utmSource = searchParams.get("utm_source");
  const utmMedium = searchParams.get("utm_medium");
  const npi = searchParams.get("npi");
  const hem = searchParams.get("hem");
  const copyrightText =
    settings?.copyright_text ||
    `© ${new Date().getFullYear()} Point Of Care Network, LLC. All Rights Reserved.`;

  const handleLinkClick = (event, refType, link) => {
    event.preventDefault(); // optional: prevents the default navigation
    console.log("Link clicked:", link);

    let payload = {
      npi: npi,
      hem: hem,
      ipAddress: ipAddress,
      engagementRefId: "Challenge Pack",
      engagementSecRefId: refType,
      distinationUrl: link,
      engagementType: "link_click",
      utmSource: utmSource,
      utmMedium: utmMedium,
      utmCampaign,
      timeToComplete: "",
      gameResult: "",
    };
    logEngagement(payload);

    // You can also do custom logic here (e.g. analytics, conditional redirects)
    window.open(link, "_blank"); // open in new tab manually
  };

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 2, sm: 3 },
        py: { xs: 2, sm: 4 },
        px: { xs: 0, sm: 0 },
        textAlign: { sm: "center", md: "left" },
        maxWidth: "unset !important",
      }}
    >
      <AdBanner />
      <Container sx={{ px: { xs: 1, md: 0 } }}>
        <Typography
          sx={{
            fontSize: { xs: "18px", md: "32px" },
            fontWeight: 700,
            color: "#333",
            textAlign: "center",
          }}
        >
          Take the {programData.name} Challenge!
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "14px", md: "18px" },
            fontWeight: 500,
            color: "#d11717",
            textAlign: "center",
          }}
        >
          How much do you know about {programData.name}?
        </Typography>
        <Container
          sx={{
            px: { xs: 0 },
            display: "flex",
            flexDirection: "column",
            gap: 4,
          }}
        >
          {programData.categories.map((category, index) => {
            return <ChallengePack data={category} key={index} />;
          })}
        </Container>
      </Container>

      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 4, sm: 8 },
          mt: 5,
          py: { xs: 3, sm: 4 },
          px: { xs: 6 },
          textAlign: { sm: "center", md: "left" },
          bgcolor: "#fff",
          borderTop: "1px solid #707070",
          maxWidth: "unset !important",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { md: "row", sm: "column", xs: "column" },
            gap: { md: 5, sm: 4, xs: 4 },
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: {
                md: "flex-start",
                sm: "center",
                xs: "center",
              },
              gap: 4,
              width: { md: "45%", sm: "100%" },
            }}
          >
            <Box
              component="img"
              src={`${
                settings && settings.footer_logo
                  ? process.env.REACT_APP_API_IMAGE_URL + settings.footer_logo
                  : "/assets/images/POCN_Logo-White_TM_285x120.png"
              }`}
              alt="logo of sitemark"
            ></Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { md: "row", sm: "column", xs: "column" },
              gap: { md: 5, sm: 3, xs: 1 },
              width: { md: "50%", sm: "100%", xs: "100%" },
              justifyContent: "space-between",
            }}
          >
            <Box display="flex" flexDirection="column" gap={1}>
              <Link
                href={
                  settings && settings.privacy_policy_link
                    ? settings.privacy_policy_link
                    : "#"
                }
                onClick={(e) =>
                  handleLinkClick(
                    e,
                    "Privacy Policy",
                    settings && settings.privacy_policy_link
                      ? settings.privacy_policy_link
                      : "#",
                  )
                }
                target="_blank"
                sx={{ color: "#001232" }}
              >
                Privacy Policy
              </Link>
              <Link
                href={
                  settings && settings.americas_top_link
                    ? settings.americas_top_link
                    : "#"
                }
                onClick={(e) =>
                  handleLinkClick(
                    e,
                    "Your Privacy Choices",
                    settings && settings.americas_top_link
                      ? settings.americas_top_link
                      : "#",
                  )
                }
                target="_blank"
                sx={{ color: "#001232" }}
              >
                Your Privacy Choices
                <img
                  src={privacyOptions}
                  alt="privacy options"
                  class="img-privacy"
                />
              </Link>
            </Box>
            <Box display="flex" flexDirection="column" gap={1}>
              <Link
                href={
                  settings && settings.contact_us_link
                    ? settings.contact_us_link
                    : "#"
                }
                onClick={(e) =>
                  handleLinkClick(
                    e,
                    "Contact Us",
                    settings && settings.contact_us_link
                      ? settings.contact_us_link
                      : "#",
                  )
                }
                target="_blank"
                sx={{ color: "#001232" }}
              >
                Contact Us
              </Link>
              <Link
                href={
                  settings && settings.terms_link ? settings.terms_link : "#"
                }
                onClick={(e) =>
                  handleLinkClick(
                    e,
                    "Terms of Use",
                    settings && settings.terms_link ? settings.terms_link : "#",
                  )
                }
                target="_blank"
                sx={{ color: "#001232" }}
              >
                Terms of Use
              </Link>
            </Box>
            <Box display="flex" flexDirection="column" gap={1}>
              <Link
                href={
                  settings && settings.pocn_plus_link
                    ? settings.pocn_plus_link
                    : "#"
                }
                onClick={(e) =>
                  handleLinkClick(
                    e,
                    "POCN+",
                    settings && settings.pocn_plus_link
                      ? settings.pocn_plus_link
                      : "#",
                  )
                }
                target="_blank"
                sx={{ color: "#001232" }}
              >
                POCN+
              </Link>
              <Link
                href={
                  settings && settings.learning_hub_link
                    ? settings.learning_hub_link
                    : "#"
                }
                onClick={(e) =>
                  handleLinkClick(
                    e,
                    "Learning Hub",
                    settings && settings.learning_hub_link
                      ? settings.learning_hub_link
                      : "#",
                  )
                }
                target="_blank"
                sx={{ color: "#001232" }}
              >
                Learning Hub
              </Link>
            </Box>
            <Box display="flex" flexDirection="column" gap={1}>
              <Link
                href={`${
                  settings && settings.be_a_leader_link
                    ? settings.be_a_leader_link
                    : "https://www.pocn.com/ambassador-program/"
                }`}
                onClick={(e) =>
                  handleLinkClick(
                    e,
                    "Ambassador Program",
                    settings && settings.be_a_leader_link
                      ? settings.be_a_leader_link
                      : "https://www.pocn.com/ambassador-program/",
                  )
                }
                target="_blank"
                sx={{ color: "#001232" }}
              >
                Ambassador Program
              </Link>
            </Box>
          </Box>
        </Box>
        <Box
          width="100%"
          py={3}
          display="flex"
          flexDirection={{ md: "row", xs: "column-reverse" }}
          justifyContent="space-between"
          alignItems="center"
          borderTop="1px solid #707070"
        >
          <Typography
            sx={{
              fontSize: { md: "17px", sm: "16px", xs: "14px" },
              fontWeight: 400,
              color: "#414042",
              textAlign: { sm: "left", xs: "center" },
            }}
          >
            {copyrightText}
          </Typography>
          <Stack
            direction="row"
            justifyContent="left"
            spacing={1}
            useFlexGap
            sx={{
              color: "text.secondary",
            }}
          >
            <IconButton
              color="inherit"
              href={`${
                settings && settings.facebook_link
                  ? settings.facebook_link
                  : "https://facebook.com/POCNInc"
              }`}
              onClick={(e) =>
                handleLinkClick(
                  e,
                  "Facebook Footer Icon",
                  settings && settings.facebook_link
                    ? settings.facebook_link
                    : "https://facebook.com/POCNInc",
                )
              }
              target="_blank"
              aria-label="facebook"
              sx={{ alignSelf: "center" }}
            >
              <FacebookRoundedIcon fontSize="medium" />
            </IconButton>
            <IconButton
              color="inherit"
              href={`${
                settings && settings.twitter_link
                  ? settings.twitter_link
                  : "https://twitter.com/POCNInc"
              }`}
              onClick={(e) =>
                handleLinkClick(
                  e,
                  "Twitter Footer Icon",
                  settings && settings.twitter_link
                    ? settings.twitter_link
                    : "https://twitter.com/POCNInc",
                )
              }
              target="_blank"
              aria-label="twitter"
              sx={{ alignSelf: "center" }}
            >
              <TwitterIcon fontSize="medium" />
            </IconButton>
            <IconButton
              color="inherit"
              href={`${
                settings && settings.linkedin_link
                  ? settings.linkedin_link
                  : "https://www.linkedin.com/company/pocn/"
              }`}
              onClick={(e) =>
                handleLinkClick(
                  e,
                  "Linkedin Footer Icon",
                  settings && settings.linkedin_link
                    ? settings.linkedin_link
                    : "https://www.linkedin.com/company/pocn/",
                )
              }
              target="_blank"
              aria-label="linkedin"
              sx={{ alignSelf: "center" }}
            >
              <LinkedInIcon fontSize="medium" />
            </IconButton>
            <IconButton
              color="inherit"
              href={`${
                settings && settings.instagram_link
                  ? settings.instagram_link
                  : "https://www.instagram.com/pocninc/"
              }`}
              onClick={(e) =>
                handleLinkClick(
                  e,
                  "Instagram Footer Icon",
                  settings && settings.instagram_link
                    ? settings.instagram_link
                    : "https://www.instagram.com/pocninc/",
                )
              }
              target="_blank"
              aria-label="instagram"
              sx={{ alignSelf: "center" }}
            >
              <InstagramIcon fontSize="medium" />
            </IconButton>
          </Stack>
        </Box>
      </Container>
    </Container>
  );
};

export default Home;
